export function arraysEquivalent(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    console.error('Both arguments must be arrays');
    return false;
  }

  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every(item =>
    arr1.filter(x => x === item).length === arr2.filter(x => x === item).length
  );
}
